/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { FormControl, TextField, MenuItem, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from '@mui/material/Select';
import useStyles from '../styles';
import { updateFrom } from '../../../redux/Actions/createInstance.action';
import { ADD_INFO } from '../../../redux/Constants/createInstance.constants';
import Services from './Services';

const MainTextField = styled(TextField)(() => ({
    input: {
        height: '10px'
    }
}));
const MainSelect = styled(Select)(() => ({
    height: '43px',
    fontSize: '14px'
}));

function Info(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { allReleases } = useSelector((state) => state.constants.settings);
    const [mainInfo, setMainInfo] = useState({
        type: 'Enterprise',
        version: allReleases[0],
        annpackage: 'Platinum',
        accStatus: 'Running',
        location: 'Us West (Oregon)',
        heading: '',
        hostname: '',
        tenantId: '',
        harborRepo: '',
        startDate: `${moment()}`,
        endDate: `${moment()}`
    });
    const [openBuildDialog, setOpenBuildDialog] = useState(false);

    const handleChange = (val) => (e) => {
        setMainInfo({
            ...mainInfo,
            [val]: e.target.value
        });
    };

    const handleChangeDate = (val) => (e) => {
        setMainInfo({
            ...mainInfo,
            [val]: e.toDate()
        });
        props.setInvalidDateError(false);
        props.setInvalidDateErrorEnd(false);
        props.setDateRangeError(false);
    };

    const handleFocusEnd = () => {
        props.setInvalidDateErrorEnd(false);
        props.setDateRangeError(false);
    };
    useEffect(() => {
        dispatch(updateFrom(mainInfo, ADD_INFO));
    }, [mainInfo]);

    useEffect(() => {
        const data = props.val;
        if (props.val.licenseType) {
            setMainInfo({
                type: data.licenseType,
                version: data.releaseVersion,
                annpackage: data.annualSupportPackage,
                accStatus: data.status,
                location: data.dataCenter,
                hostname: data.hostname,
                tenantId: data.tenantId,
                harborRepo: data.harborRepo,
                startDate: data.subscriptionStartDate,
                endDate: data.subscriptionEndDate,
                services: data.services || []
            });
        }
    }, [props.val]);

    return (
        <div>
            <div className={classes.formContainer}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>License Type</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainSelect
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={mainInfo.type}
                                onChange={handleChange('type')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            >
                                <MenuItem value="Enterprise">Enterprise</MenuItem>
                                <MenuItem value="Limited">Limited</MenuItem>
                            </MainSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>
                            Release Version
                            <span style={{ float: 'right' }}>
                                <Button variant="text" onClick={() => setOpenBuildDialog(true)}>
                                    Advance Settings
                                </Button>
                            </span>
                        </div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainSelect
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={mainInfo.version}
                                onChange={handleChange('version')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            >
                                {allReleases &&
                                    allReleases.map((release) => (
                                        // eslint-disable-next-line react/jsx-key
                                        <MenuItem value={release}>{release}</MenuItem>
                                    ))}
                            </MainSelect>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Annual Support Package</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainSelect
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={mainInfo.annpackage}
                                onChange={handleChange('annpackage')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            >
                                <MenuItem value="Platinum">Platinum</MenuItem>
                                <MenuItem value="Gold">Gold</MenuItem>
                                <MenuItem value="Silver">Silver</MenuItem>
                                <MenuItem value="Premium">Premium</MenuItem>
                                <MenuItem value="Standard">Standard</MenuItem>
                            </MainSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Subscription Start Date</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    onChange={handleChangeDate('startDate')}
                                    value={mainInfo.startDate}
                                    InputLabelProps={{
                                        style: { fontSize: '13px' }
                                    }}
                                    renderInput={(params) => (
                                        <MainTextField
                                            {...params}
                                            onFocus={() => props.setInvalidDateError(false)}
                                            error={props.invalidDateError}
                                            helperText={props.invalidDateError && 'Invalid date'}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Subscription End Date</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    minDate={new Date(mainInfo.startDate)}
                                    selected={mainInfo.endDate}
                                    onChange={handleChangeDate('endDate')}
                                    value={mainInfo.endDate}
                                    InputLabelProps={{
                                        style: { fontSize: '13px' }
                                    }}
                                    renderInput={(params) => (
                                        <MainTextField
                                            {...params}
                                            onFocus={handleFocusEnd}
                                            error={
                                                props.invalidDateErrorEnd || props.dateRangeError
                                            }
                                            helperText={
                                                (props.dateRangeError &&
                                                    'End Date must be greater than Start Date') ||
                                                (props.invalidDateErrorEnd && 'Invalid date')
                                            }
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Account Status</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainSelect
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={mainInfo.accStatus}
                                onChange={handleChange('accStatus')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            >
                                <MenuItem value="Live">Live</MenuItem>
                                <MenuItem value="On Trial">On Trial</MenuItem>
                                <MenuItem value="Running">Running</MenuItem>
                                <MenuItem value="Closed">Closed</MenuItem>
                            </MainSelect>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Data Center Location</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainTextField
                                disabled
                                id="outlined-basic"
                                variant="outlined"
                                value={mainInfo.location}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                                // onBlur={(e) => setLocation(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Hostname</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainTextField
                                id="outlined-basic"
                                variant="outlined"
                                value={mainInfo.hostname}
                                onChange={handleChange('hostname')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>Tenant Id*</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainTextField
                                disabled={props.isEditable}
                                onFocus={() => props.setIsTenantInvalid(false)}
                                error={props.isTenantInvalid}
                                helperText={props.isTenantInvalid && 'Required field'}
                                id="outlined-basic"
                                variant="outlined"
                                value={mainInfo.tenantId}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                                onChange={handleChange('tenantId')}
                                ref={props.tenantIdRef}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/* <div className={classes.divAdjust}> */}
                        <div className={classes.inputHead}>Harbor Repository</div>
                        <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                            <MainTextField
                                id="outlined-basic"
                                variant="outlined"
                                value={mainInfo.harborRepo}
                                onChange={handleChange('harborRepo')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            />
                        </FormControl>
                        {/* </div> */}
                    </Grid>
                </Grid>
                <Services
                    open={openBuildDialog}
                    editMode
                    setOpenBuildDialog={setOpenBuildDialog}
                    mainInfo={mainInfo}
                    clientSettings={mainInfo}
                    setMainInfo={setMainInfo}
                />
            </div>
        </div>
    );
}

export default React.memo(Info);
